import React, { useState } from 'react'
import { CustomerModel } from 'shared/models/CutomerDeliveryLocations/CustomerModel'

interface IProps {
  customers: CustomerModel[]
  onClick: (selectedCustomer: CustomerModel) => void
}

const MultipleCustomerData = (props: IProps) => {
  const [selectedCustomerRow, setSelectedCustomerRow] =
    useState<CustomerModel>()

  const onClickCustomer = (customerRow: CustomerModel) => {
    setSelectedCustomerRow(customerRow)
    props.onClick(customerRow)
  }

  const renderCustomers = () => {
    return props.customers.map(c => {
      return (
        <tr
          onClick={() => onClickCustomer(c)}
          className={
            selectedCustomerRow == c ? 'tddata table-primary' : 'tddata'
          }
        >
          <td className='tddata'>{c.customerNumber}</td>
          <td className='tddata'>{c.customerName}</td>
          <td className='tddata'>{c.customerEanCode}</td>
        </tr>
      )
    })
  }

  return (
    props.customers != null && (
      <table className='table'>
        <thead>
          <tr className='tablesubheader'>
            <th colSpan={3}>Klant</th>
          </tr>
        </thead>
        <tbody>
          <tr className='tablesubheader'>
            <td>Klantnummer</td>
            <td>Naam</td>
            <td>EAN</td>
          </tr>
          {renderCustomers()}
        </tbody>
      </table>
    )
  )
}
export default MultipleCustomerData
